import { mb } from '../../Themes/utilities';
import { rem } from 'polished';
import Icon from '../../Icon';
import React from 'react';
import StatusBar from '../StatusBar';
import styled, { css, useTheme } from 'styled-components';
const ResponsiveLabel = styled.div `
  display: none;
  ${mb('l')} {
    display: flex;
    ${({ $withMargin }) => $withMargin &&
    css `
        margin-left: ${rem(12)};
      `}
  }
`;
const StatusBarAction = ({ icon, label, onClick }) => {
    let IconEl = null;
    const theme = useTheme();
    if (icon) {
        if (typeof icon === 'string') {
            IconEl = React.createElement(Icon, { size: "l", name: icon, color: theme.color.primary });
        }
        else {
            IconEl = icon;
        }
    }
    return (React.createElement(StatusBar.Button, { onClick: onClick },
        IconEl,
        label && (React.createElement(ResponsiveLabel, { "$withMargin": !!IconEl }, label))));
};
export default React.memo(StatusBarAction);
